import { FlexBox } from '@dixa/lib-shared-habla';
import type { ConversationSpeakMediaMessageAddedEvent } from 'lib-shared-types-api';
import { User } from 'lib-shared-types-api';

import {
  ConversationEventGroupConfigBase,
  ConversationEventGroupPropBase,
} from 'components/conversation/conversationEventGroups/conversationEventGroups.types';
import { PrivateMediaPlayer } from 'components/privateMediaPlayer';

import { ConversationMessageEventBox } from '../../messageEventBox/conversationMessageEventBox';

/** Represents the conversation audio event group configuration. */
export type ConversationAudioEventGroupConfig =
  ConversationEventGroupConfigBase<
    'group:pstn_phone' | 'group:voicemail',
    Pick<ConversationAudioEventGroupProps, 'allowDownload'>
  >;

type ConversationAudioEventGroupProps = ConversationEventGroupPropBase<
  ConversationSpeakMediaMessageAddedEvent,
  {
    /** The author of the message. */
    author?: User;
    /** Whether it's allowed to download the audio. */
    allowDownload?: boolean;
  }
>;

export const ConversationAudioEventGroup = ({
  allowDownload,
  className,
  events,
}: ConversationAudioEventGroupProps): JSX.Element => {
  return (
    <ConversationMessageEventBox className={className} variant="audio">
      <FlexBox flexDirection="column" gap="250">
        {events.map((event) => {
          const src =
            event.channel === 'pstn_phone'
              ? event.recording_url
              : event.voicemail_url;

          return src ? (
            <PrivateMediaPlayer
              key={event.id}
              noControlsStyle
              mediaFile={{ src, type: 'audio' }}
              controls={{ download: allowDownload }}
            />
          ) : null;
        })}
      </FlexBox>
    </ConversationMessageEventBox>
  );
};
